/**
 * RTK Query endpoints for the billing PrepaidCoverage action-POST surfaces.
 *
 * All three endpoints are action-POSTs (not REST CRUD) that operate on
 * collections of coverage IDs or radio assignments. Grid reads are served
 * by EntityGrid's dataSource and are not duplicated here.
 */

import { entitiesApi } from './entitiesApi';

export const prepaidCoveragesApi = entitiesApi.injectEndpoints({
  endpoints: build => ({
    createPrepaidCoveragePlan: build.mutation({
      query: ({ body }) => ({ url: 'billing/prepaid-coverages/create-plan/', method: 'post', data: body }),
      transformResponse: b => b.data ?? b,
      invalidatesTags: [{ type: 'PrepaidCoverage', id: 'LIST' }],
    }),

    editPrepaidCoverage: build.mutation({
      query: ({ body }) => ({ url: 'billing/prepaid-coverages/edit/', method: 'post', data: body }),
      transformResponse: b => b.data ?? b,
      invalidatesTags: [{ type: 'PrepaidCoverage', id: 'LIST' }],
    }),

    convertPrepaidRadios: build.mutation({
      query: ({ body }) => ({ url: 'billing/prepaid-coverages/convert/', method: 'post', data: body }),
      transformResponse: b => b.data ?? b,
      invalidatesTags: [{ type: 'PrepaidCoverage', id: 'LIST' }],
    }),
  }),
});

export const { useCreatePrepaidCoveragePlanMutation, useEditPrepaidCoverageMutation, useConvertPrepaidRadiosMutation } =
  prepaidCoveragesApi;
